import { Component, OnInit, Output, EventEmitter, Input, ViewChild } from '@angular/core';
import { User } from '../shared/user.model';
import { TYPEMODULE, LoaderService, NotificationService, UtilityService, CONSTANT, ICONS, ACTIONS, EVENTO } from '../../../../shared/session/index';
import { UserService } from '../shared/user.service';
import { FileuploadComponent } from 'src/app/shared/fileupload/fileupload.component';

@Component({
  selector: 'app-user-view',
  templateUrl: 'user-view.component.html'
})
export class UserViewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @ViewChild('imagenAnversoComponent') imagenAnversoComponent: FileuploadComponent;
  @ViewChild('imagenReversoComponent') imagenReversoComponent: FileuploadComponent;
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;

  user: User;
  msgErrorGet: string;
  buttonGroup: any;
  public typeImage: number;

  constructor(
    private loaderService: LoaderService,
    private userService: UserService,
    private notificationService: NotificationService,
    private utilityService: UtilityService,
  ) { }

  ngOnInit() {
    this.user = new User();
    this.msgErrorGet = 'Error al obtener datos';
    this.typeImage = CONSTANT.typeImage.view;
    this.obtenerUser(this.data.user.ID);
    this.buttonGroup = [
      { icon: ICONS.add, tooltip: 'NUEVO DOCUMENTO', action: ACTIONS.newDocumento },
    ];
  }

  fabButtonEmit(action: any) {
    switch (action) {
      case ACTIONS.newDocumento:
        this.onNewDocumento();
        break;
      default:
        break;
    }
  }

  onNewDocumento() {
    this.changeEvent({ evento: EVENTO.crearDocumento, data: this.data });
  }

  changeEvent(event) {
    this.onChangeEvent.emit(event);
  }

  obtenerUser(id: number): void {
    this.loaderService.show();
    this.userService.obtenerUser(id)
      .subscribe(res => {
        this.user = res;
        this.utilityService.setAuditoria(this.user);
        this.imagenAnversoComponent.getFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, this.user.FotoRuta);
        this.imagenReversoComponent.getFile(CONSTANT.imagen.clase.imagen, CONSTANT.imagen.tipo.usuario, this.user.imagenReverso);
      },
        error => {
          this.notificationService.error(this.msgErrorGet);
          throw error;
        },
        () => {
          this.loaderService.hide();
        });
  }
}
